// extracted by mini-css-extract-plugin
export default {"inpuStyle":"src-components-Antd-DatePicker-css__inpuStyle--jA4ht"};